import { type ReactNode } from 'react'

import { Link } from 'react-router-dom'
import reactStringReplace from 'react-string-replace'

import { type IPostTag } from '../types/interfaces/ITypes'

export const renderPostText = (
  text: string | null | undefined,
  tags: IPostTag[] | null | undefined = []
): ReactNode => {
  if (typeof text !== 'string') {
    return ''
  }

  if (!Array.isArray(tags) || !tags.length) {
    return text
  }

  let result: ReactNode[] | string = text

  tags.forEach((tag, tagIndex) => {
    const user = tag?.user

    if (!user?.id || !user?.username) {
      return
    }

    const mentionToken =
      `@{{${user.id}||${user.username}||__avatarUrl__}}`

    result = reactStringReplace(
      result,
      mentionToken,
      (_match, matchIndex) => (
        <Link
          key={`${user.id}-${tagIndex}-${matchIndex}`}
          to={`/${user.username}`}
        >
          @{user.username}
        </Link>
      )
    )
  })

  return result
}